// You can write more code here

/* START OF COMPILED CODE */

import PreloadScene from "../core/scenes/PreloadScene";
import PreloadImage from "../core/components/PreloadImage";
/* START-USER-IMPORTS */
import { assetsToLoad } from '../assets-to-load';
import { app } from '../core/App';
import { TransitionPoint } from '../app-routing';
/* END-USER-IMPORTS */

export default class PreloadBatwheels extends PreloadScene {

  constructor() {
    super("PreloadBatwheels");

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {

    // bg
    const bg = this.add.rectangle(960, 383, 1920, 768);
    bg.isFilled = true;
    bg.fillColor = 923958;

    // outline
    const outline = this.add.image(960, 648, "preloader-batwheels", "loading-bar-bg.png");

    // preloaderBg
    const preloaderBg = this.add.image(960, 648, "preloader-batwheels", "loading-bar-fill.png");
    preloaderBg.scaleX = 0.98;

    // preloadBar
    const preloadBar = this.add.image(960, 648, "preloader-batwheels", "loading-bar-bg.png");

    // logo
    const logo = this.add.image(960, 364, "preloader-batwheels", "logo-batwheels.png");

    // preloadBar (components)
    new PreloadImage(preloadBar);

    this.outline = outline;
    this.preloaderBg = preloaderBg;
    this.preloadBar = preloadBar;
    this.logo = logo;

    this.events.emit("scene-awake");
  }

  private outline!: Phaser.GameObjects.Image;
  private preloaderBg!: Phaser.GameObjects.Image;
  private preloadBar!: Phaser.GameObjects.Image;
  private logo!: Phaser.GameObjects.Image;

  /* START-USER-CODE */

  // Write your code here

  public preload() {
    this.editorCreate();

    this.add.tween({
      targets: this.logo,
      scaleX: 1.03,
      scaleY: 1.03,
      duration: 2000,
      ease: Phaser.Math.Easing.Quadratic.InOut,
      yoyo: true,
      repeat: -1
    });

    super.preload();

    assetsToLoad(this);

    this.load.on(Phaser.Loader.Events.COMPLETE, this.postload, this);
  }

  public postload() {
    super.postload();
  }

  public create() {
    super.create();
  }


  protected finish() {
    super.finish();

    app.afterPreload(() => {
      app.gotoNextScene(this, TransitionPoint.PreloadEnd, { test: 'test' });
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
